import './App.css';
import { Helmet } from 'react-helmet';
import LandingPage from './unAuth/LandingPage';

// import './firebase';

function App() {
  return (
    <>
      <Helmet>
        <title>TubeStamp</title>
        <meta name="description" content="Create and manage timestamps for YouTube videos" />
        <meta name="keywords" content="YouTube, timestamps, video, timestamp generator, video timestamps" />
        <meta name="google-adsense-account" content={process.env.REACT_APP_AD_SENSE || 'ca-pub-8752240601841755'} />
      </Helmet>
      <div className="App app-theme">
      <div className="app-container">
        <LandingPage />
      </div>
    </div>
    </>
  );
}

export default App;
